var $cfc0b125c9f0edea$exports = {};
$cfc0b125c9f0edea$exports = {
    "alert": `\u{8B66}\u{793A}`,
    "dismiss": `\u{95DC}\u{9589}`
};


export {$cfc0b125c9f0edea$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
